import * as React from 'react';

import { WrappedFC } from '../shared/types';

interface Props {
  /** 表示するコンポーネントの種類 */
  type: 'description' | 'lead' | 'detail' | 'staticContentLinks';
}

const DEFAULT_COMPONENT: keyof JSX.IntrinsicElements = 'div';

/**
 * 説明文字列コンポーネント
 * 改行文字を含む文字列は改行タグに置き換える処理を行う
 */
export const Description: WrappedFC<typeof DEFAULT_COMPONENT, Props> = ({
  type,
  className,
  element: Element = DEFAULT_COMPONENT,
  ...props
}) => {
  const _clsName = className || type;
  const renderMultilineTexts = () => {
    if (typeof props.children === 'string') {
      // グループ付きの正規表現でsplitすると、改行文字のみの要素ができるので
      // それを改行タグに置き換えて出力する
      // (タグが無いとJSXで出力できないので、仕方なくspanしている)
      const splitted = props.children.split(/(\n)/);
      return splitted.map((value, index) => (
        <span key={index}>{value.match(/\n/) ? <br /> : value}</span>
      ));
    } else {
      return props.children;
    }
  };
  return (
    <Element {...props} className={_clsName}>
      {renderMultilineTexts()}
    </Element>
  );
};
Description.displayName = 'Description';
